import { __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
var DeviceApiClient = /** @class */ (function (_super) {
    __extends(DeviceApiClient, _super);
    // /**
    //  * Custom constructor that supports timeout property.
    //  *
    //  * @param {union} baseURL the base URL stack, string or async function that returns string of the desired Stratus stack, which should be obtained from the API discovery service
    //  * @param {JarvisAuthProvider} authProvider the auth provider for requests this client will make
    //  * @param {timeout} request timeout, defaults to 0 (no timeout) if not provided
    //  */
    function DeviceApiClient(baseURL, authProvider, timeout) {
        var _this = _super.call(this, baseURL, authProvider) || this;
        _this.apiName = 'ws-hp.com/devices';
        _this.apiVersion = '1';
        _this.timeout = 0;
        _this.timeout = timeout;
        return _this;
    }
    /**
     * Retrieves the list of the devices of the authenticated user
     *
     * @returns Axios response object
     */
    DeviceApiClient.prototype.listDevices = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceApiClient.deviceListSchema(),
                        timeout: this.timeout,
                    })];
            });
        });
    };
    /**
     * Retrieves summary of device identities, status and capabilities
     * (so we can get ultimatelly modelNumber)
     * @param cloudId
     * @returns Axios response object
     */
    DeviceApiClient.prototype.getDevice = function (cloudId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceApiClient.getDeviceSchema(),
                        url: "/".concat(cloudId),
                        timeout: this.timeout,
                    })];
            });
        });
    };
    /**
     * Retrieves supplies status for a device
     * @param cloudId
     * @returns Axios response object
     */
    DeviceApiClient.prototype.getDeviceSuppliesStatus = function (cloudId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceApiClient.getDeviceSuppliesStatusSchema(),
                        url: "/".concat(cloudId, "/suppliesStatus"),
                        timeout: this.timeout,
                    })];
            });
        });
    };
    /**
     * Retrieves details for a given model number
     * @param modelNumber
     * @returns
     */
    DeviceApiClient.prototype.getModelDetails = function (modelNumber) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: "/models/".concat(modelNumber),
                        timeout: this.timeout,
                    })];
            });
        });
    };
    /**
     * Retrieves the device status
     *
     * @returns Axios response object
     */
    DeviceApiClient.prototype.getDeviceStatus = function (cloudId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        validationSchema: DeviceApiClient.getDeviceStatusSchema(),
                        url: "/".concat(cloudId, "/status"),
                        timeout: this.timeout,
                    })];
            });
        });
    };
    DeviceApiClient.deviceListSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['devices'],
            additionalProperties: true,
            properties: {
                devices: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: ['deviceIdentity'],
                        additionalProperties: true,
                        properties: {
                            deviceIdentity: {
                                type: 'object',
                                required: ['serialNumber', 'modelName', 'modelNumber'],
                                additionalProperties: true,
                                properties: {
                                    serialNumber: { type: 'string' },
                                    modelName: { type: 'string' },
                                    modelNumber: { type: 'string' },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceApiClient.getDeviceSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['deviceDescription'],
            properties: {
                deviceDescription: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['deviceIdentity'],
                    properties: {
                        deviceIdentity: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['modelNumber'],
                            properties: {
                                modelNumber: { type: 'string' },
                            },
                        },
                    },
                },
            },
        };
    };
    DeviceApiClient.getDeviceSuppliesStatusSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
        };
    };
    DeviceApiClient.getDeviceStatusSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            additionalProperties: true,
            required: ['state'],
            properties: {
                state: {
                    type: 'object',
                    additionalProperties: true,
                    required: ['reported'],
                    properties: {
                        reported: {
                            type: 'object',
                            additionalProperties: true,
                            required: ['cdmData'],
                            properties: {
                                cdmData: {
                                    type: 'object',
                                    additionalProperties: true,
                                    required: [
                                        'printerState',
                                        'printerStateReasons',
                                        'printerIsAcceptingJobs',
                                        'printerStateSeverity',
                                    ],
                                    properties: {
                                        printerState: {
                                            type: 'string',
                                            enum: [
                                                'not_a_printer',
                                                'idle',
                                                'processing',
                                                'stopped',
                                                'NOT_A_PRINTER',
                                                'IDLE',
                                                'PROCESSING',
                                                'STOPPED',
                                            ],
                                        },
                                        printerStateReasons: {
                                            type: 'array',
                                            items: {
                                                type: 'string',
                                                enum: [
                                                    'none',
                                                    'other',
                                                    'media-needed',
                                                    'media-jam',
                                                    'paused',
                                                    'shutdown',
                                                    'toner-low',
                                                    'toner-empty',
                                                    'spool-full',
                                                    'door-open',
                                                    'cover-open',
                                                    'media-empty',
                                                    'marker-supply-low',
                                                    'marker-supply-empty',
                                                    'media-low',
                                                    'NONE',
                                                    'OTHER',
                                                    'MEDIA-NEEDED',
                                                    'MEDIA-JAM',
                                                    'PAUSED',
                                                    'SHUTDOWN',
                                                    'TONER-LOW',
                                                    'TONER-EMPTY',
                                                    'SPOOL-FULL',
                                                    'DOOR-OPEN',
                                                    'COVER-OPEN',
                                                    'MEDIA-EMPTY',
                                                    'MARKER-SUPPLY-LOW',
                                                    'MARKER-SUPPLY-EMPTY',
                                                    'MEDIA-LOW',
                                                    'MEDIA_NEEDED',
                                                    'MEDIA_JAM',
                                                    'TONER_LOW',
                                                    'TONER_EMPTY',
                                                    'SPOOL_FULL',
                                                    'DOOR_OPEN',
                                                    'COVER_OPEN',
                                                    'MEDIA_EMPTY',
                                                    'MARKER_SUPPLY_LOW',
                                                    'MARKER_SUPPLY_EMPTY',
                                                    'MEDIA_LOW',
                                                ],
                                            },
                                        },
                                        printerIsAcceptingJobs: {
                                            type: 'string',
                                            enum: ['no', 'yes', 'NO', 'YES'],
                                        },
                                        printerStateSeverity: {
                                            type: 'string',
                                            enum: [
                                                'none',
                                                'report',
                                                'warning',
                                                'error',
                                                'NONE',
                                                'REPORT',
                                                'WARNING',
                                                'ERROR',
                                            ],
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        };
    };
    return DeviceApiClient;
}(StratusClient));
export { DeviceApiClient };
//# sourceMappingURL=device-api.js.map